import React, { useEffect } from "react";
import { useAppDispatch } from "../../../store/hooks";
import {
  getDistrictList,
  getDivisionList,
  getSeatList,
  getUpazilaList,
} from "../../../store/apis";
import NetaVideosCreateForm from "../../../components/Admin/NetaVideos/NetaVideosCreateForm";
import { createNetaVideos } from "../../../store/API/MemberApis";
import { useNavigate } from "react-router-dom";

const CreateNetaVideos = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(getDivisionList());
    dispatch(getDistrictList());
    dispatch(getUpazilaList());
    dispatch(getSeatList());
  }, [dispatch]);

  const handleSubmit = async (formData: any,memberData:any, videoTypeData:any,  thumbnail: File | null) => {
    console.log(formData, thumbnail, memberData, "formData, thumbnail");
    
    const formDataToSubmit = new FormData();
    // Append all the form data (text inputs) to FormData
    Object.keys(formData).forEach((key) => {
      const value = formData[key as keyof typeof formData];
      if (value !== null && value !== undefined && value !== "") {
        formDataToSubmit.append(key, value);
      }
    });
    // Append thumbnail as a file (only if a file was selected)
    if (thumbnail) {
      formDataToSubmit.append("thumbnail", thumbnail);
    }
    if (memberData) {
      formDataToSubmit.append("member_id", memberData.value.toString());
    }
    if (videoTypeData) {
      formDataToSubmit.append("videoType", videoTypeData.label.toString());
    }
    // Dispatch the createNeta action with the FormData
    dispatch(createNetaVideos({ formData: formDataToSubmit, navigate }));
  };
  return (
    <div className="flex flex-col gap-4 px-4 pt-6 text-start justify-center">
      <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-gray-800 w-full">
        <div className="border-b border-stroke py-4 px-6 dark:border-strokedark">
          <h3 className="font-semibold text-black dark:text-white">
            Create Neta
          </h3>
        </div>
        <NetaVideosCreateForm onSubmit={handleSubmit} />
      </div>
    </div>
  );
};

export default CreateNetaVideos;
